import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {OaseMenu} from '../../interfaces/oase-menu';
import {OpeningHours} from 'src/app/interfaces/opening-hours';
import {ToastController} from '@ionic/angular';

@Component({
  selector: 'app-oasemenu',
  templateUrl: './oasemenu.page.html',
  styleUrls: ['./oasemenu.page.scss'],
})
export class OasemenuPage implements OnInit {
  // declare variables
  public assets = environment.assets;
  public menuslunch: OaseMenu[] = [];
  public menusdinner: OaseMenu[] = [];
  public menusbusiness: OaseMenu[] = [];
  public menuswines: OaseMenu[] = [];
  public date = new Date();
  public today = new Date();
  public tomorrow = new Date();
  public dayaftertomorrow = new Date();
  public openingHours: any;
  public titles: any;
  public menuTab: any;
  public dateSelector: any;
  public isWeekend: boolean;
  public holiday: [];
  public isDinnerHoliday: boolean;
  public isNormalHoliday: boolean;
  public menuDinnerAvailable: boolean;
  public menuBusinessAvailable: boolean;
  public oasenewvisitorData: any = null;
  public loadingNewVisitor: boolean = false;
  public oaseNewVisitorApiData: any = null; // Store full API data for new visitor
  public selectedDayNewVisitor: number = 0; // 0 = Monday, 4 = Friday
  public selectedDay: string = '0'; // 0 = Monday, 4 = Friday for main menu
  public showDebugInfo: boolean = false; // Set to true to show debug information

  // constructor
  constructor(
      private http: HttpClient,
      public toastController: ToastController,
  ) {
    this.menuTab = 'lunch';
    this.dateSelector = 'today';
    this.tomorrow = new Date(this.tomorrow.setDate(this.today.getDate() + 1));
    this.dayaftertomorrow = new Date(this.dayaftertomorrow.setDate(this.today.getDate() + 2));
    
    // Initialize selectedDayNewVisitor to current day
    const today = new Date();
    const day = today.getDay();
    const currentDayIndex = day === 0 ? 6 : day - 1;
    this.selectedDayNewVisitor = currentDayIndex < 5 ? currentDayIndex : 0;
    this.selectedDay = currentDayIndex < 5 ? currentDayIndex.toString() : '0';
  }

  // on init
  ngOnInit() {
    this.prepareMenus();
    this.loadOaseNewVisitor();
    this.presentToast();
  }

  // check if the date is weekend
  public checkWeekend(date) {
    this.isWeekend = (date.getDay() === 6) || (date.getDay() === 0);
  }

  // prepare the OASE menus
  public prepareMenus() {
    // Check if weekend
    this.checkWeekend(this.date);
    
    // Get day of week (0 = Monday, 4 = Friday)
    const day = this.date.getDay();
    const dayIndex = day === 0 ? 6 : day - 1;
    const weekIndex = dayIndex < 5 ? dayIndex : 0;

    this.getMenus().subscribe((res: any) => {
      // Get oaseLunch restaurant data - it's under week.restaurants
      const oaseLunchData = res.week?.restaurants?.oaseLunch || null;
      
      if (!oaseLunchData || !oaseLunchData.menus) {
        console.log('No oaseLunch data found');
        return;
      }

      // Get singleDayTypes - it's under week.singleDayTypes
      const singleDayTypes = res.week?.singleDayTypes || {};

      // Get menu types for oaseLunch
      const menuTypes = Object.keys(oaseLunchData.menus).sort((a, b) => {
        return (oaseLunchData.menus[a].position || 0) - (oaseLunchData.menus[b].position || 0);
      });

      // Map menu types to OaseMenu format
      this.menuslunch = menuTypes.map(menuType => {
        const menuItems = singleDayTypes[menuType];
        const menuInfo = oaseLunchData.menus[menuType];
        // Get display name from API (nameEn for English, name for German)
        const displayName = menuInfo?.nameEn || menuInfo?.name || menuType;
        console.log(`Menu type ${menuType}:`, menuItems);
        
        if (!menuItems || !Array.isArray(menuItems)) {
          console.log(`No menu items found for ${menuType}`);
          return <OaseMenu>{
            title: displayName,
            starter: '',
            main: '',
            price: '',
            dessert: '',
            dprice: ''
          };
        }
        
        const dayMenu = menuItems.find((m: any) => m.weekIndex === weekIndex);
        console.log(`Day menu for ${menuType} at weekIndex ${weekIndex}:`, dayMenu);
        
        if (!dayMenu) {
          console.log(`No day menu found for ${menuType} at weekIndex ${weekIndex}`);
          return <OaseMenu>{
            title: displayName,
            starter: '',
            main: '',
            price: '',
            dessert: '',
            dprice: ''
          };
        }

        return <OaseMenu>{
          title: displayName,
          starter: dayMenu.soup || '',
          main: dayMenu.main || '',
          price: dayMenu.price || '',
          dessert: dayMenu.dessert || '',
          dprice: ''
        };
      });
      
      console.log('Final menuslunch:', this.menuslunch);

      // Business lunch - businessLunch and businessLunchVegi are in week.singleDayTypes
      // Get oaseNewVisitor restaurant data for menu names
      const oaseNewVisitorData = res.week?.restaurants?.oaseNewVisitor || null;
      
      const businessMenuTypes = ['businessLunch', 'businessLunchVegi'].filter(mt => 
        singleDayTypes[mt] && Array.isArray(singleDayTypes[mt])
      );
      
      console.log('Business menu types found:', businessMenuTypes);
      console.log('Business menu items:', businessMenuTypes.map(mt => ({ type: mt, items: singleDayTypes[mt] })));
      
      this.menusbusiness = businessMenuTypes.map(menuType => {
        const menuItems = singleDayTypes[menuType];
        const menuInfo = oaseNewVisitorData?.menus?.[menuType];
        // Get display name from API (nameEn for English, name for German)
        const displayName = menuInfo?.nameEn || menuInfo?.name || menuType;
        
        if (!menuItems || !Array.isArray(menuItems)) {
          console.log(`No menu items found for business ${menuType}`);
          return <OaseMenu>{
            title: displayName,
            starter: '',
            main: '',
            price: '',
            dessert: ''
          };
        }
        
        const dayMenu = menuItems.find((m: any) => m.weekIndex === weekIndex);
        console.log(`Business day menu for ${menuType} at weekIndex ${weekIndex}:`, dayMenu);
        
        if (!dayMenu) {
          console.log(`No day menu found for business ${menuType} at weekIndex ${weekIndex}`);
          return <OaseMenu>{
            title: displayName,
            starter: '',
            main: '',
            price: '',
            dessert: ''
          };
        }

        this.menuBusinessAvailable = !!(dayMenu.main || dayMenu.starter || dayMenu.soup || dayMenu.dessert);

        return <OaseMenu>{
          title: displayName,
          starter: dayMenu.starter || dayMenu.soup || '',
          main: dayMenu.main || '',
          price: dayMenu.price || '',
          dessert: dayMenu.dessert || ''
        };
      });
      
      if (businessMenuTypes.length === 0) {
        this.menuBusinessAvailable = false;
      }
      
      console.log('Final menusbusiness:', this.menusbusiness);

      // Get opening hours from settings
      const openingHours = res.settings?.openingHours || {};
      this.openingHours = Object.keys(openingHours).map(key => {
        const oh = openingHours[key];
        return <OpeningHours>{
          title: oh.title || key,
          value: oh.text || ''
        };
      });
    });
  }

  // get the all the menus of the OASE Mealplanner
  public getMenus() {
    return this.http.get(environment.foodmarket_api);
  }

  // get all the holidays from the PSI
  public getHolidays() {
    return this.http.get(environment.holiday_api);
  }

  // changes the date of the menus
  public switchDate() {
    if (this.dateSelector == 'today') {
      this.date = this.today;
      this.prepareMenus();
    } else if (this.dateSelector == 'tomorrow') {
      this.date = this.tomorrow;
      this.prepareMenus();
    } else if (this.dateSelector == 'dayaftertomorrow') {
      this.date = this.dayaftertomorrow;
      this.prepareMenus();
    }
  }

  // load Oase New Visitor data from mealplannerv2/data API
  public loadOaseNewVisitor() {
    this.loadingNewVisitor = true;
    this.http.get(environment.foodmarket_api).subscribe(
      (data: any) => {
        // Store full API data
        this.oaseNewVisitorApiData = data;
        // Extract oaseNewVisitor data from the API response - it's under week.restaurants
        this.oasenewvisitorData = data.week?.restaurants?.oaseNewVisitor || null;
        this.loadingNewVisitor = false;
        console.log('Oase New Visitor API Data:', this.oasenewvisitorData);
        console.log('Full API Data:', data);
      },
      (error) => {
        this.loadingNewVisitor = false;
        console.error('Error loading Oase New Visitor data:', error);
      }
    );
  }

  // Get menu items for Oase New Visitor for a specific day and menu type
  public getNewVisitorMenuItems(menuType: string, dayIndex: number): any[] {
    // singleDayTypes is under week.singleDayTypes
    const singleDayTypes = this.oaseNewVisitorApiData?.week?.singleDayTypes || {};
    
    if (!this.oaseNewVisitorApiData || !singleDayTypes || !singleDayTypes[menuType]) {
      return [];
    }
    
    const menuItems = singleDayTypes[menuType];
    if (!Array.isArray(menuItems)) {
      return [];
    }
    const dayMenu = menuItems.find((m: any) => m.weekIndex === dayIndex);
    return dayMenu ? [dayMenu] : [];
  }

  // Get all menu types for oaseNewVisitor
  public getNewVisitorMenuTypes(): string[] {
    if (!this.oasenewvisitorData || !this.oasenewvisitorData.menus) return [];
    return Object.keys(this.oasenewvisitorData.menus).sort((a, b) => {
      return (this.oasenewvisitorData.menus[a].position || 0) - (this.oasenewvisitorData.menus[b].position || 0);
    });
  }

  // Get menu type info for new visitor
  public getNewVisitorMenuTypeInfo(menuType: string): any {
    return this.oasenewvisitorData?.menus?.[menuType] || null;
  }

  // Get day name for new visitor
  public getDayNameNewVisitor(index: number): string {
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    return days[index] || '';
  }

  // Get all API data for new visitor
  public getAllNewVisitorApiData(): any {
    return this.oaseNewVisitorApiData;
  }

  // Get multiDayTypes
  public getNewVisitorMultiDayTypes(): any {
    return this.oaseNewVisitorApiData?.week?.multiDayTypes || null;
  }

  // Get all restaurants
  public getNewVisitorRestaurants(): any {
    return this.oaseNewVisitorApiData?.week?.restaurants || null;
  }

  // Get all single day types
  public getNewVisitorSingleDayTypes(): any {
    return this.oaseNewVisitorApiData?.week?.singleDayTypes || {};
  }

  // Get single day type keys
  public getNewVisitorSingleDayTypeKeys(): string[] {
    const types = this.getNewVisitorSingleDayTypes();
    if (!types) return [];
    return Object.keys(types);
  }

  // Get soups
  public getNewVisitorSoups(): any[] {
    return this.oaseNewVisitorApiData?.week?.soups || [];
  }

  // Get published status
  public getNewVisitorPublished(): boolean {
    return this.oaseNewVisitorApiData?.published || false;
  }

  // Get holidays
  public getNewVisitorHolidays(): any[] {
    return this.oaseNewVisitorApiData?.holidays || [];
  }

  // Get settings
  public getNewVisitorSettings(): any {
    return this.oaseNewVisitorApiData?.settings || null;
  }

  // Get opening hours
  public getNewVisitorOpeningHours(): any {
    return this.oaseNewVisitorApiData?.settings?.openingHours || null;
  }

  // Get defaults
  public getNewVisitorDefaults(): any {
    return this.oaseNewVisitorApiData?.settings?.defaults || null;
  }

  // Get all informations
  public getNewVisitorAllInformations(): any {
    return this.oaseNewVisitorApiData?.settings?.informations || null;
  }

  // Get week info
  public getNewVisitorWeekInfo(): any {
    return this.oaseNewVisitorApiData?.week || null;
  }

  // Get uploaded time
  public getNewVisitorUploadedTime(): string {
    return this.oaseNewVisitorApiData?.uploaded || null;
  }

  // get all new visitor data properties
  public getNewVisitorProperties(): string[] {
    if (!this.oasenewvisitorData) return [];
    return Object.keys(this.oasenewvisitorData);
  }

  // notification for english speakers (user)
  async presentToast() {
    // Check if mobile to position toast at top
    const isMobile = window.innerWidth <= 768;
    this.toastController.create({
      animated: true,
      color: 'dark',
      duration: 5000,
      message: 'Most of this information is available in German only.',
      position: isMobile ? 'top' : 'bottom',
      translucent: true,
      buttons: [{
        text: 'X',
        role: 'cancel'
      }]
    }).then((toastData) => {
      toastData.present();
    });
  }

}
